<template>
  <div class="grid-x">
    <div class="cell small-12 large-7">
      <div class="grid-x border-top small-margin-top-s small-padding-top-s large-margin-top-m large-padding-top-m">
        <h3 class="h3 small-12 medium-3 medium-padding-right-xxxl" v-text="returnItems.heading"></h3>
        <div class="small-12 medium-7 medium-offset-2 small-margin-top-xs medium-margin-top-z">
          <Skeleton height="400px" />
        </div>
      </div>
      <div class="grid-x border-top small-margin-top-s small-padding-top-s large-margin-top-m large-padding-top-m">
        <h3 class="small-12 medium-3 medium-padding-right-xxxl">Your Options</h3>
      </div>
      <div class="grid-x border-top small-margin-top-s small-padding-top-s large-margin-top-m large-padding-top-m">
        <h3 class="small-12 medium-3 medium-padding-right-xxxl">Return Method</h3>
      </div>
    </div>
    <div class="small-12 small-border-top small-margin-top-s small-padding-top-s large-4 large-offset-1 large-margin-top-m large-padding-top-z">
      <Skeleton height="250px" />
    </div>
  </div>
</template>

<script setup>
// Imports
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton.vue';
import { returnItems } from 'config';
</script>
